import { Link } from 'react-router-dom';
import { Icon, Badge } from '@openedx/paragon';
import { RiLiveLine } from '@remixicon/react';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from './messages';

const LiveSessionCard = ({
  id,
  title,
  imageUrl,
  status,
}) => {
  const intl = useIntl();
  const statusText = (() => {
    if (status === 'live') return intl.formatMessage(messages.statusLive);
    if (status === 'ended') return intl.formatMessage(messages.statusEnded);
    return intl.formatMessage(messages.statusScheduled);
  })();
  return (
    <Link to={`/live-sessions/${id}`} className="live-session-card" aria-label={title}>
      <div
        className="live-session-card__image"
        style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : undefined}
        role="img"
        aria-label={title}
      >
        <div className="live-session-card__status-badge">
          <Badge variant="solid" color="gray" size="md">
            {statusText}
          </Badge>
        </div>
        <div className="live-session-card__type-badge">
          <Icon src={RiLiveLine} size="inline" />
          <span>{intl.formatMessage(messages.liveBadge)}</span>
        </div>
      </div>

      <div className="live-session-card__details">
        <div className="live-session-card__title">{title}</div>
      </div>
    </Link>
  );
};

export default LiveSessionCard;
